/*
 * Copyright (C) 2018 BarD Software s.r.o
 */
import {BellNotificationMethods} from './components/BellNotification';
import {
    ProjectDto,
    TeamDto,
} from './Teams';
import TeamList from './components/TeamList.vue';
import TeamPane from './components/TeamPane.vue';

export type TeamLists = 'team-own' | 'team-member' | 'team-invite';

export interface Dashboard {
    teamPane: TeamPane;
    vueTeams: TeamList;
    vueBell: BellNotificationMethods;
}

type DashboardSelectionListener = () => void;
export type DashboardSelectionListenerDestroy = () => void;
/**
 * This class holds the dashboard selection: team and project.
 */
export class DashboardSelection {
    private myTeam?: TeamDto;
    private myProject?: ProjectDto;
    private listeners: Array<DashboardSelectionListener> = [];

    set team(team: TeamDto) {
        this.myTeam = team;
        this.fireSelectionChange();
    }

    get team(): TeamDto | undefined {
        return this.myTeam;
    }

    get project(): ProjectDto | undefined {
        return this.myProject;
    }

    set project(project: ProjectDto) {
        this.myProject = project;
        this.fireSelectionChange();
    }

    public onSelectionChange(l: DashboardSelectionListener): DashboardSelectionListenerDestroy {
        this.listeners.push(l);
        return () => this.listeners = this.listeners.filter((item) => item !== l);
    }

    private fireSelectionChange() {
        this.listeners.forEach((listener) => listener());
    }

    public touch() {
        this.fireSelectionChange();
    }
}

let ourDashboardSelection = new DashboardSelection();

let ourDashboard: Dashboard | undefined;

export function setDashboard(value: Dashboard) {
    ourDashboard = value;
}

export function updateProject(projectDto: ProjectDto | null) {
    ourDashboard.teamPane.setProject(projectDto);
}

export function updateDependencies(teamDto?: TeamDto | null) {
    ourDashboard?.teamPane?.setTeam(teamDto);
}

export function getDashboardSelection(): DashboardSelection {
    return ourDashboardSelection;
}